
export const ColumnsEvents = [
  { field: 'Title', headerName: 'Event name', flex: 0.8 },
  { field: 'DateEventStartEnd', headerName: 'When', flex: 0.3 },
  { field: 'Place', headerName: 'Location', flex: 0.3 },
  { field: 'SectorGroup', headerName: 'Group', flex: 0.6 },
];

